import { render } from "./ChangeDumpBodyModal.vue?vue&type=template&id=ee23b250"
import script from "./ChangeDumpBodyModal.vue?vue&type=script&lang=js"
export * from "./ChangeDumpBodyModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/driveapp2.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__